import { render, staticRenderFns } from "./SidebarBreakdownManeger.vue?vue&type=template&id=b7e2c0ac&scoped=true"
import script from "./SidebarBreakdownManeger.vue?vue&type=script&lang=ts"
export * from "./SidebarBreakdownManeger.vue?vue&type=script&lang=ts"
import style0 from "./SidebarBreakdownManeger.vue?vue&type=style&index=0&id=b7e2c0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e2c0ac",
  null
  
)

export default component.exports